var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.dynamicMask),expression:"dynamicMask"}],attrs:{"disabled":_vm.disabled,"placeholder":_vm.field.placeholder,"type":"tel","clearable":""},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }